import { Card, CardBody, Input } from '@heroui/react';
import React from 'react';
import { FiSearch } from 'react-icons/fi';

export interface TableHeaderProps {
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  searchPlaceholder?: string;
  isLoading?: boolean;
  children?: React.ReactNode;
  className?: string;
}

export const TableHeader: React.FC<TableHeaderProps> = ({
  searchValue = '',
  onSearchChange,
  searchPlaceholder = 'Search...',
  isLoading = false,
  children,
  className = '',
}) => {
  return (
    <Card className={`mb-6 ${className}`}>
      <CardBody>
        <div className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center justify-between">
          {onSearchChange && (
            <div className="flex-1 min-w-0">
              <Input
                type="text"
                placeholder={searchPlaceholder}
                value={searchValue}
                onChange={(e) => onSearchChange(e.target.value)}
                startContent={<FiSearch className="text-default-400" />}
                variant="bordered"
                size="sm"
                aria-label="Search"
                isDisabled={isLoading}
                classNames={{
                  input: 'text-foreground bg-transparent px-3 py-2 text-sm',
                  inputWrapper:
                    'bg-default-50 border-default-200 hover:border-default-300 focus-within:border-primary h-10 shadow-sm hover:shadow-md transition-all duration-200',
                }}
              />
            </div>
          )}
          {children && (
            <div className="flex gap-2 items-center">{children}</div>
          )}
        </div>
      </CardBody>
    </Card>
  );
};
